module.exports = __WEBPACK_EXTERNAL_MODULE_28__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Cookies","commonjs2":["js-cookie"],"commonjs":"js-cookie","amd":"js-cookie"}
// module id = 28
// module chunks = 0